import { modalIds } from "@/components/modals/constants";
import { useDiscount } from "@/components/providers/discount-provider";
import { useModal } from "@/components/providers/modal-provider";
import { useApp } from "@/components/providers/app-provider";
import {
  EventNames,
  SectionTypes,
  sendEvent,
  withSectionAndFlow,
} from "@/lib/utils/analytics";
import { useSearchParams } from "next/navigation";
import { FALLBACK_DISCOUNT_CODES } from "@/lib/utils/common/constants";
import { buildCheckoutUrl } from "@/lib/utils/common/checkout-url";
import { useState } from "react";

export const useCheckout = () => {
  const { discount, isNgOutOfStock } = useDiscount();
  const { handleOpenModal } = useModal();
  const { workflow } = useApp();
  const params = useSearchParams();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleCheckout = () => {
    if (workflow === "ng" && isNgOutOfStock) {
      handleOpenModal(modalIds.notifyMe);
      sendEvent(EventNames.NOTIFY_ME_CLICKED);
    } else if (workflow === "ng") {
      const payload = withSectionAndFlow(SectionTypes.PRODUCT_SELECTION, workflow);
      sendEvent(EventNames.CHECKOUT_INTERMEDIATE_CLICKED, payload);
      sendEvent(EventNames.CHECKOUT_NOW_CLICKED, payload);
      setIsRedirecting(true);

      const checkoutUrl = buildCheckoutUrl(
        "inito-fertility-monitor-ng",
        `disc_code=${discount || FALLBACK_DISCOUNT_CODES["ng"]}&${params.toString()}`,
      );

      window.location.href = checkoutUrl;
    } else {
      sendEvent(
        EventNames.CHECKOUT_INTERMEDIATE_CLICKED,
        withSectionAndFlow(SectionTypes.PRODUCT_SELECTION, workflow),
      );
      handleOpenModal(modalIds.phoneCategory, { couponCode: discount });
    }
  };

  return { handleCheckout, isRedirecting };
};
